function renderTags(getData, parseExamples, localFullData, renderThumbs, renderAllContent, renderContentItem, swipeToContentItem, removeListenerForBodyClose, currentItem, dataForSending, modelId, params, quiz, tagsRefInfoData) {
  const tagListWrapper = document.querySelector('[data-js="tag-list"]');

  for (const key in localFullData) {
    renderCategorie(localFullData[key].id, localFullData[key].title, localFullData[key].tags, false)
  }

  tagListWrapper.querySelector(`[data-tag-id="${currentItem.id}"]`).classList.add('category__list-item_active');

  function renderCategorie(categoryId, name, categoryTags) {
    const newItem = document.createElement('div');
    newItem.classList.add('category__item');
    newItem.dataset.categoryId = categoryId;

    let currentTagData;
  
    let tagList = '';
    categoryTags.forEach((element, ind) => {
      tagsRefInfoData[element.id] = element;

      let modelStatus
      if(quiz) {
        if ('model_ready' in element && element.model_ready !== null) {
          modelStatus = `data-model-ready="${element.model_ready}"`;
        } else if ('model_ready' in element) {
          modelStatus = `data-model-ready="wait"`;
        }
      }

      tagList += `
      <li data-tag-id="${element.id}" ${modelStatus ? modelStatus : ''} class="category__list-item">
        <span>${element.title}</span>

        <div class="tag-list__item-task">${element.img ? `<span data-content-type="img" class="tag-list__item-task_img">${element.img}</span>` : ''}${element.redgifs ? `<span data-content-type="redgifs" class="tag-list__item-task_video">${element.redgifs}</span>` : ''}${element.carousel ? `<span data-content-type="carousel" class="tag-list__item-task_carousel">${element.carousel}</span>` : ''}</div>

        ${modelId != "references" && quiz ? `<div class="tag-list__item-status">
          <div data-tag-status-button="yes" class="tag-list__item-button tag-list__item-button_yes ${element.model_ready == "yes" ? "tag-list__item-button_active" : ""}">Yes</div>
          <div data-tag-status-button="no" class="tag-list__item-button tag-list__item-button_no ${element.model_ready == "no" ? "tag-list__item-button_active" : ""}">No</div>
        </div>` : ''}         
      </li>`;
    });
  
    newItem.innerHTML = `
    <h2 class="alert alert-dark category__list-button">
      ${name}
    </h2>
    <ul data-tags-category="${name}" class="category__list list-group">
      ${tagList}
    </ul>`;
  
    newItem.addEventListener('click', (event) => {
      const button = event.target;
      const tag = button.closest('[data-tag-id]');

      if (button.dataset.tagStatusButton) {
        console.log('click on status button')

        if (!tag || button.classList.contains('tag-list__item-button_active')) {
          return;
        }

        tag.dataset.modelReady = button.dataset.tagStatusButton;
        tag.querySelector('.tag-list__item-button_active') ? tag.querySelector('.tag-list__item-button_active').classList.remove('tag-list__item-button_active') : null;
        button.classList.add('tag-list__item-button_active');

        getData(`./update.php?model_id=${modelId}&tag_id=${tag.dataset.tagId}&model_ready=${button.dataset.tagStatusButton}`);
        return
      }

      if (!tag || tag.classList.contains('category__list-item_active')) {
        return
      }

      dataForSending.tagId = tag.dataset.tagId;

      categoryTags.forEach((tagData, ind) => {
        if (tagData.id == tag.dataset.tagId) currentTagData = localFullData[categoryId].tags[ind]; 
      });

      const parseRes = parseExamples(currentTagData);
      const parsedExamples = parseRes.exampleArray;
      const contentStartIndexes = parseRes.contentStartIndexes;

      if (window.innerWidth < 992) {
        if (button.dataset.contentType) { 
          if (!button.classList.contains('tag-list__list-item_chosen')) {
            renderAllContent(currentTagData);
            params.set('tag', currentTagData.title.trim());
          }

          swipeToContentItem(contentStartIndexes[button.dataset.contentType]);

          removeListenerForBodyClose();
          document.querySelector('[data-js="workspace-interface"]').classList.toggle('workspace__interface_active');
          document.querySelector('[data-js="tag-list-toggle"]').classList.remove('header__mob-menu_active');

          params.set('type', button.dataset.contentType);
          changeCategoryInList();

          return;
        }

        renderAllContent(currentTagData);
        document.querySelector('[data-js="workspace-interface"]').classList.toggle('workspace__interface_active');
        document.querySelector('[data-js="tag-list-toggle"]').classList.remove('header__mob-menu_active');
        removeListenerForBodyClose();
      } else {
        if (button.dataset.contentType) {
          if (parsedExamples[contentStartIndexes[button.dataset.contentType]]) {
            //double render - need to fix
            renderThumbs(currentTagData, contentStartIndexes[button.dataset.contentType]);
            renderContentItem(parsedExamples[contentStartIndexes[button.dataset.contentType]]);

            params.set('type', button.dataset.contentType);
          } else {
            renderThumbs(currentTagData, 0);
            params.set('type', "all");
          }

          params.set('tag', currentTagData.title.trim());
          changeCategoryInList();

          return;
        }

        renderThumbs(currentTagData, 0);
      }

      params.set('tag', currentTagData.title.trim());
      params.set('type', String("all").trim());
      changeCategoryInList();

      function changeCategoryInList() {
        const newParams = params.toString().split('&').filter(p => !p.startsWith(modelId)).join('&');
        history.pushState(null, '', `?${modelId}${newParams ? '&' + newParams : ''}`);

        currentItem.id = currentTagData.id;

        document.querySelector('[data-js="content-task"]').innerHTML = `${currentTagData.img > 0 ? `<span>${currentTagData.img} images</span>` : ''}${currentTagData.redgifs > 0 ? `<span>${currentTagData.redgifs} video</span>` : ''}${currentTagData.carousel > 0 ? `<span>${currentTagData.carousel} carousel</span>` : ''}${(!currentTagData.img && !currentTagData.redgifs && !currentTagData.carousel) ? '<span>No required items</span>' : ''}`;

        tagListWrapper.querySelector('.category__list-item_active').classList.remove('category__list-item_active');
        button.closest('[data-tag-id]').classList.add('category__list-item_active');
      }
    });
  
    tagListWrapper.append(newItem);
  }
}


export default renderTags;